import { useContext } from 'react';

import { NotificationsContext } from './NotificationsContext';

export const useNotificationsContext = () => useContext(NotificationsContext);
